export const tabModeDeleted = {
    deletedList: 'deleted-list',
    inactiveList: 'inactive-list',
} as const;

export const tabMode = {
    ...tabModeDeleted,
    mainList: 'main-list',
} as const;

export type TTabModeDeleted = (typeof tabModeDeleted)[keyof typeof tabModeDeleted];
export type TTabMode = (typeof tabMode)[keyof typeof tabMode];
